/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Floors = {
    type: 'array',
    contains: {
        type: 'Floor',
    },
};